module.exports = __webpack_public_path__ + "static/media/calendar-2.fcb59f66.png";